import { productV2ActionsTypes } from '../../actions/inventory/productV2Actions';

const ProductV2Reducers = (state = {}, action) => {
  switch (action.type) {
  case productV2ActionsTypes.CREATE_LEDGER_ENTRY.LOADING: {
    const { createLedgerEntryLoading } = action;

    return {
      ...state,
      createLedgerEntryLoading,
    };
  }

  case productV2ActionsTypes.UPDATE_LEDGER_ENTRY.LOADING: {
    const { updateLedgerEntryLoading } = action;

    return {
      ...state,
      updateLedgerEntryLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default ProductV2Reducers;
